<template>
    <div class="contact">
      <c-banner></c-banner>
      <div class="contact-box">
        <h3 class="contact-h3">填入你的基本信息</h3>
        <el-row :gutter="10" class="pb50">
          <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11">
            <div class="int-title"><span class="int-title-left">* </span><span class="int-title-right">姓名</span></div>
            <el-input @blur="changeActiveFalse1" v-model="intOne" placeholder="请输入您的姓名"></el-input>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2"><div style="height: 10px;"></div></el-col>
          <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11">
            <div class="int-title"><span class="int-title-left">* </span><span class="int-title-right">电话</span></div>
            <el-input @blur="changeActiveFalse2" v-model="intTwo" placeholder="请输入您的手机号码"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="pb50">
          <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11">
            <div class="int-title"><span class="int-title-left">* </span><span class="int-title-right">企业/组织名称</span></div>
            <el-input @blur="changeActiveFalse3" v-model="intThird" placeholder="请输入公司名称"></el-input>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2"><div style="height: 10px;"></div></el-col>
          <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11">
            <div class="int-title"><span class="int-title-left">* </span><span class="int-title-right">邮箱</span></div>
            <el-input @blur="changeActiveFalse4" v-model="intFouth" placeholder="请输入您的邮箱号码"></el-input>
          </el-col>
        </el-row>
        <h3 class="contact-h3">{{services[0].title}} <span class="contact-span">{{services[0].choice}}</span></h3>
        <div style="margin-top: 20px">
          <el-checkbox-group class="pb40" v-model="checkedLabel0">
            <el-row :gutter="10" class="pb20" v-for="(item,index) in services[0].service" :key="index">
              <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
                <el-checkbox :label="item.label1"></el-checkbox>
              </el-col>
              <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2"><div style="height: 10px;"></div></el-col>
              <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
                <el-checkbox :label="item.label2"></el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </div>
        <h3 class="contact-h3">{{services[1].title}} <span class="contact-span">{{services[1].choice}}</span></h3>
        <div style="margin-top: 20px">
          <el-checkbox-group class="pb40" v-model="checkedLabel1">
            <el-row :gutter="10" class="pb20" v-for="(item,index) in services[1].service" :key="index">
              <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
                <el-checkbox :label="item.label1" v-if="item.label1"></el-checkbox>
              </el-col>
              <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2"><div style="height: 10px;"></div></el-col>
              <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
                <el-checkbox :label="item.label2"  v-if="item.label2"></el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </div>
        <!--<p>您需要的服务: {{ checkedLabel0 }}</p>-->
        <!--<p>您最关注的地方: {{ checkedLabel1 }}</p>-->

        <h3 class="contact-h3">您所属的领域 <span class="contact-span">(单选)</span></h3>
        <div style="margin-top: 20px">
          <el-row :gutter="10" class="pb50">
            <el-col style="margin-bottom: 20px;" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
              <el-radio v-model="radio1" label="教育" value="教育">教育</el-radio>
            </el-col>
            <el-col style="margin-bottom: 20px;" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
              <el-radio v-model="radio1" label="医疗" value="医疗">医疗</el-radio>
            </el-col>
            <el-col style="margin-bottom: 20px;" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
              <el-radio v-model="radio1" label="交通" value="交通">交通</el-radio>
            </el-col>
            <el-col style="margin-bottom: 20px;" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
              <el-radio v-model="radio1" label="制造业" value="制造业">制造业</el-radio>
            </el-col>
            <el-col style="margin-bottom: 20px;" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
              <el-radio v-model="radio1" label="零售业" value="零售业">零售业</el-radio>
            </el-col>
            <el-col style="margin-bottom: 20px;" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
              <el-radio v-model="radio1" label="餐饮" value="餐饮">餐饮</el-radio>
            </el-col>
            <el-col style="margin-bottom: 20px;" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
              <el-radio v-model="radio1" label="娱乐" value="娱乐">娱乐</el-radio>
            </el-col>
            <el-col style="margin-bottom: 20px;" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
              <el-radio v-model="radio1" label="服务" value="服务">服务</el-radio>
            </el-col>
            <el-col style="margin-bottom: 20px;" :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
              <el-radio v-model="radio1" label="其他" value="其他">其他</el-radio>
            </el-col>
          </el-row>
        </div>

        <h3 class="contact-h3">您的开发预算 <span class="contact-span">(单选)</span></h3>
        <div style="margin-top: 20px">
          <el-row :gutter="10" class="pb50">
            <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
              <el-radio v-model="radio" label="1-10万" value="1-10万">1-10万</el-radio>
            </el-col>
            <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
              <el-radio v-model="radio" label="10-30万" value="10-30万">10-30万</el-radio>
            </el-col>
            <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
              <el-radio v-model="radio" label="30-50万" value="30-50万">30-50万</el-radio>
            </el-col>
            <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
              <el-radio v-model="radio" label="50万以上" value="50万以上">50万以上</el-radio>
            </el-col>
          </el-row>
          <!--<p>您的开发预算: {{ radio }}</p>-->
        </div>
        
        <h3 class="contact-h3">您的需求</h3>
        <div style="margin-top: 20px">
          <div style="padding-left: 12px; margin-bottom: 8px"><span style="color: rgba(209,23,23,1);">*</span> 您希望绽放工场能帮助您和企业解决哪些问题请留言告诉我们～</div>
          <el-row :gutter="10" class="pb40">
            <el-col>
              <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 7}"
                placeholder="此处简要阐述你的需求"
                v-model="textarea">
              </el-input>
            </el-col>
          </el-row>
          <!--<p>textarea: {{textarea}}</p>-->
        </div>
        <div style="margin-top: 20px">
          <div class="submit-int" @click="postValue()">立即咨询</div>
        </div>
      </div>
    </div>
</template>

<script>
  import cBanner from './customized/banner'
  export default {
    components: {
      cBanner,
    },
    data () {
      return {
        services: [
          {
            title: '您需要的服务',
            choice: '(多选)',
            a: 'checkedLabel0',
            service: [
              {
                label1: '微信应用开发（小程序、公众号）',
                label2: '企业门户网站开发'
              },
              {
                label1: 'APP定制开发',
                label2: '系统集成开发'
              },
              {
                label1: '商城开发',
                label2: '其他'
              }
            ]
          },
          {
            title: '您的私人定制',
            choice: '(多选)',
            a: 'checkedLabel1',
            service: [
              {
                label1: '对功能要求较高',
                label2: '对界面设计要求较高'
              },
              {
                label1: '对性能要求较高（高并发及负载）',
                label2: '比较注重实用性'
              },
              {
                label1: '其他'
              }
            ]
          }
        ],
        intOne: '',
        intTwo: '',
        intThird: '',
        intFouth: '',
        NewNumber:'',
        OldNumber:'',
        number:'',
        name: '',
        checkedLabel0: ['现有网站改版'],
        checkedLabel1:[],
        radio: '',
        radio1: '',
        textarea:'',
      }
    },
    methods: {
      open() {
        this.$message('请勿重覆提交');
      },
      open2() {
        this.$message({
          message: '信息提交成功！',
          type: 'success'
        });
      },
      open3() {
        this.$message({
          message: '请勿重覆提交',
          type: 'warning'
        });
      },
      open4() {
        this.$message('姓名不能为空');
      },
      open5() {
        this.$message('电话不能为空');
      },
      open6() {
        this.$message('电话输入有误');
      },
      open7() {
        this.$message('姓名、电话未输入或输入有误');
      },
      changeActiveFalse1 () {
        if(this.intOne){
          this.name= this.intOne;
        }else{
          this.open4();
        }
      },
      changeActiveFalse2 () {
        var that = this;
        if(that.intTwo){
          var aStr = that.intTwo;
          if(!(/^0\d{2,3}-?\d{7,8}$|^1(3|6|4|5|8)[0-9]\d{8}$/.test(aStr))){
            this.open6();
            that.NewNumber = '';
            console.log('我是空'+that.NewNumber);
          }else{
            that.NewNumber = that.intTwo;
          }
        }else{
          this.open5();
        }
      },
      changeActiveFalse3 () {
      },
      changeActiveFalse4 () {
      },
      // 提交给后台
      postValue () {
        if (this.name != '' && this.NewNumber != '' && this.NewNumber != this.OldNumber && this.intOne != '' && this.intTwo != '') {
          // this.OldNumber = this.NewNumber;
          // var url = 'https://zsxc.email.bloomworks.cn/sendMail';
          // var json = {
          //   name: this.name,
          //   phone: this.number,
          //   companyname: this.intThird,
          //   eail: this.intFouth,
          //   service: this.checkedLabel0,
          //   requirements: this.checkedLabel1,
          //   budget: this.radio,
          //   messageboard: this.textarea
          // }
          let base = `基本信息：\n    姓名：${this.name}\n    电话：${this.intTwo}\n    企业/组织名称：${this.intThird}\n    邮箱：${this.intFouth}\n`
          let service = '服务需求：\n    ' + this.checkedLabel0.join('，') + '\n'
          let custom = `定制需求：\n    ` + this.checkedLabel1.join('，') + '\n'
          let field = `所属领域：\n    ${this.radio}\n`
          let budget = `开发预算：\n    ${this.radio}\n` 
          let message = `备注信息： \n    ${this.textarea}`
          this.axios({
            method: 'post',
            url: 'https://zsxc.email.bloomworks.cn/mail/sendMail',
            data: {
              text: base + service + custom + field + budget + message
            },
            header: {
              'content-type': 'application/json'
            },
          }).then(function (res) {
            console.log(res);
          }).catch(function (err) {
            console.log(err);
          });
          this.open2();
        } else if(this.NewNumber != '' && this.NewNumber == this.OldNumber){
          this.open3();
        } else{
          this.open7();
        }

      }
    }
  }
</script>
<style scoped>
  .contact{
    position: relative;
    width: 100%;
    background-size: cover;
    padding-bottom: 80px;
  }
  .contact-box{
    height: auto;
    margin: 48px auto;
    padding: 40px 30px 55px;
    background: #ffffff;
    overflow: hidden;
    max-width:1000px;
    background:rgba(255,255,255,1);
    box-shadow:0px 6px 24px 0px rgba(151,151,151,0.16);
  }
  .contact h2 {
    text-align: center;
    padding: 80px 0 60px 0;
  }
  .contact-h3{
    margin-bottom: 25px;
    font-size:20px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(51,51,51,1);
  }
  .contact-span{
    font-size: 14px;
    color: #999999;
    font-weight: 400;
  }

  .int-box{
    position: relative;
    width: 100%;
    height: 38px;
  }
  .int-box input{
    width: 100%;
    line-height: 38px;
    font-size: 18px;
    outline:none;
    border-bottom: 1px solid #e6e6e6;
    line-height: 38px;
    font-size: 18px;
    color: #666;
  }
  .int-box input:focus{
    border-bottom: 1px solid #666666;
  }
  .a-span{
    position: absolute;
    left: 0;
    top: 0;
    line-height:38px;
    color: #666;
    font-size: 18px;
    z-index: 1;
    transition: all .8s;
  }
  .active .a-span{
    left: 0;
    top:-25px;
    font-size: 14px;
    color: #888;
  }
  .int-icon{
    position: absolute;
    right: 10%;
    top: 10px;
    color: #ff574e;
    font-size: 20px;
  }
  .submit-int{
    text-align: center;
    line-height: 48px;
    cursor: pointer;
    width:294px;
    height:48px;
    background:rgba(209,23,23,1);
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(255,255,255,1);
    margin: auto;
  }
  .submit-int:hover {
    background: #ff7676;
  }
  .pb50{
    padding: 0 20px 40px;
  }
  .pb40{
    padding: 0 20px 20px;
  }
  .pb20{
    padding-bottom: 30px;
  }
  .int-title {
    font-size:16px;
    font-family:Microsoft YaHei;
    font-weight:400;
    margin-bottom: 8px;
  }
  .int-title-left {
    color:rgba(209,23,23,1);
  }
  .int-title-right {
    color:#333333;
  }
  .contact >>> .el-input__inner {
    border-radius: 0;
  }
  .contact >>> .el-checkbox__label {
    font-size: 16px;
  }
  .contact >>> .el-checkbox__input {
    transform: scale(1.5);
    margin-right: 10px;
  }
  .contact >>> .el-radio__label {
    font-size: 16px;
  }
  .contact >>> .el-radio__input.is-checked+.el-radio__label {
    color: #606266;
  }
  .contact >>> .el-radio__input {
    transform: scale(1.4);
    margin-top: -2px;
  }
  @media (max-width: 1199px) and (min-width: 992px){
    .contact h2 {
      text-align: center;
      padding: 60px 0;
    }
    .fs42 {
      font-size: 36px;
    }
    .contact{
      padding-bottom: 60px;
    }
    .contact-box{
      padding: 40px 80px 40px;
    }
    .pb50{
      padding: 0 20px 40px;
    }
    .a-span,.int-box input,.a-text{
      font-size: 16px;
    }
    .a-int{
      height: 50px;
      font-size: 20px;
    }
  }
  @media (max-width: 991px) and (min-width: 768px){
    .contact h2 {
      text-align: center;
      padding: 40px 0;
    }
    .fs42 {
      font-size: 30px;
    }
    .contact{
      padding-bottom: 40px;
    }
    .contact-box{
      padding: 40px 80px 40px;
    }
    .pb50{
      padding-bottom:30px;
    }
    .a-span,.int-box input,.a-text{
      font-size: 14px;
    }
    .a-int{
      height: 40px;
      font-size: 18px;
    }
  }
  @media screen and (max-width: 767px){
    .contact h2 {
      text-align: center;
      padding: 27px 0;
      font-size: 20px;
      line-height: 24px;
    }
    .fs42 {
      font-size: 24px;
    }
    .contact{
      padding-bottom: 30px;
    }
    .contact-box{
      padding: 40px 80px 40px;
    }
    .pb50{
      padding-bottom:20px;
    }
    .a-span,.int-box input,.a-text{
      font-size: 13px;
    }
    .a-int{
      height: 40px;
      font-size: 16px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/customized.vue